<template>
  <form autocomplete="off">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-1/2 justify-right">
        <h2 class="pl-2">{{$t('labels.templates')}}</h2>
      </div>
    </div>
    <vx-card class="mb-6" :title="$t('labels.select_service')">
      <div class="vx-col w-full md:w-1/3 sm: p-0 md:pl-3 md:pr-3 mb-4">
        <v-select
          v-model="service"
          :options="services_drop"
          :reduce="services_drop => services_drop"
          label="name"
          name="services"
          class="mt-1"
          v-validate="'required'"
          :closeOnSelect="true"
        />
        <span class="text-danger text-sm">{{ errors.first('services') }}</span>
      </div>
    </vx-card>
    <vx-card
      :title="$t('labels.executive_summary_template')"
      class="addedit-service-card"
      v-if="service"
    >
      <div class="w-full m-0">
        <div class="example">
          <ckeditor :config="editorConfig" v-model="content" :value="content"></ckeditor>
        </div>
      </div>
      <div class="mt-4 btn-lead text-center">
        <vs-button
          class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
          :disabled="button_loading"
          button="button"
          @click="saveData()"
        >{{ $t('labels.save_template') }}</vs-button>
      </div>
    </vx-card>
  </form>
</template>
<script>
import Vue from "vue";
import CKEditor from "ckeditor4-vue";
Vue.use(CKEditor);
export default {
  data() {
    return {
      editorConfig: {
        toolbar: [
          {
            name: "basicstyles",
            groups: ["basicstyles", "cleanup"],
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
              "-",
              "CopyFormatting",
              "RemoveFormat"
            ]
          },
          {
            name: "paragraph",
            groups: ["list", "indent", "align", "bidi"],
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
              "-",
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
              "-",
              "BidiLtr"
            ]
          },
          { name: "insert", items: ["Table", "HorizontalRule", "PageBreak"] },
          "/",
          {
            name: "document",
            groups: ["mode", "document", "doctools"],
            items: ["Preview", "Print", "-"]
          },
          {
            name: "clipboard",
            groups: ["clipboard", "undo"],
            items: ["Cut", "Copy", "Paste", "PasteText", "-", "Undo", "Redo"]
          },
          {
            name: "editing",
            groups: ["find", "selection", "spellchecker"],
            items: ["Find", "Replace", "-", "SelectAll", "-"]
          },
          "/",
          { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "tools", items: ["Maximize"] },
          { name: "others", items: ["-"] }
          // { name: 'about', items: [ 'About' ] }
        ]
      },
      content: this.content,
      templateId: "",
      service: "",
      services_drop: []
      //content: this.content,
    };
  },
  methods: {
    async saveData() {
      let input = {
        data: this.content
      };
      let response = await this.getHTTPPostResponse(
        "privilege/update/" + this.templateId,
        input,
        "",
        true
      );
    },
    async getServices() {
      let input = {
        name: this.service
      };
      let response = await this.getHTTPPostResponse("/services/list", input);
      if (response) {
        let service_req = response.data.services;
        let filteredServices = [];
        for (var i = 0; i < service_req.length; i++) {
          if(service_req[i].id === 1 || service_req[i].id === 2|| service_req[i].id === 3 || service_req[i].id === 4 || service_req[i].id === 5)
          {
            let obj = { id: service_req[i].id, name: service_req[i].name };
            filteredServices.push(obj);
          }
        }
        this.services_drop = filteredServices;
      }
    },
    async getData() {
      let response = await this.getHTTPGetResponse(
        "privilege/get/" + this.service.id
      );
      if (response) {
        let data = response.data;
        let contentData = data.privilege_data.data;
        this.content = contentData;
        this.templateId = data.privilege_data.id;
      }
    }
  },
  mounted: function() {
    this.getServices();
  },
  watch: {
    service(val) {
      this.getData();
    }
  }
};
</script>
<style scoped>
body {
  font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif !important;
}
</style>
